/**
* Adapted from http://www.codrops.com
*
* Original code licensed under the MIT license.
* http://www.opensource.org/licenses/mit-license.php
*
* Copyright 2014, Codrops
* http://www.codrops.com
*/
;(function(window) {
    'use strict';

    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    }

    function SVGAnimator(el, options) {
        this.el = el;
        this.options = extend({}, this.options);
        extend(this.options, options);
        this._init();
    }

    SVGAnimator.prototype.options = {
        speedIn : 500,
        speedOut : 500,
        easingIn : mina.linear,
        easingOut : mina.linear
    }

    SVGAnimator.prototype._init = function() {
        var s = Snap( this.el.querySelector( 'svg' ) );
        this.path = s.select( 'path' );
        this.initialPath = this.path.attr('d');

        var openingStepsStr = this.el.getAttribute('data-opening');
        this.openingSteps = openingStepsStr ? openingStepsStr.split(';') : '';
        this.openingStepsTotal = openingStepsStr ? this.openingSteps.length : 0;
        if (this.openingStepsTotal === 0) return;

        // if data-closing is not defined then the path will animate to its original shape
        var closingStepsStr = this.el.getAttribute('data-closing') ? this.el.getAttribute('data-closing') : this.initialPath;
        this.closingSteps = closingStepsStr ? closingStepsStr.split(';') : '';
        this.closingStepsTotal = closingStepsStr ? this.closingSteps.length : 0;

        this.isAnimating = false;
    }

    SVGAnimator.prototype.show = function(onOpen) {
        if (this.isAnimating) return false;
        this.isAnimating = true;
        // animate svg
        var self = this,
        onEndOpenAnimation = function() {
            classie.addClass(self.el, 'is-open');
            if (onOpen && typeof onOpen == 'function') {
                onOpen();
            }
        };
        this._animateSVG('in', onEndOpenAnimation);
        classie.add(this.el, 'is-active');
    }

    SVGAnimator.prototype.hide = function(onClose) {
        var self = this,
        onEndCloseAnimation = function() {
            // reset path
            self.path.attr('d', self.initialPath);
            classie.removeClass(self.el, 'is-active');

            if (onClose && typeof onClose == 'function') {
                onClose();
            }

            self.isAnimating = false;
        };

        classie.removeClass(this.el, 'is-open');
        this._animateSVG('out', onEndCloseAnimation);
    }

    SVGAnimator.prototype._animateSVG = function( dir, callback ) {
        var self = this,
        pos = 0,
        steps = dir === 'out' ? this.closingSteps : this.openingSteps,
        stepsTotal = dir === 'out' ? this.closingStepsTotal : this.openingStepsTotal,
        speed = dir === 'out' ? self.options.speedOut : self.options.speedIn,
        easing = dir === 'out' ? self.options.easingOut : self.options.easingIn,
        nextStep = function( pos ) {
            if ((pos > stepsTotal - 1) || (speed == 0)) {
                if (callback && typeof callback == 'function') {
                    callback();
                }
                return;
            }

            self.path.animate({ 'path' : steps[pos] }, speed, easing, function() { nextStep(pos); });
            pos++;
        };

        nextStep(pos);
    }

    // add to global namespace
    window.SVGAnimator = SVGAnimator;

})(window);
